import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.011" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M7.492 5.993A.5.5 0 007 6.501V9H5.5a.5.5 0 100 1h2a.5.5 0 00.5-.5v-3a.5.5 0 00-.508-.508z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M7.5 3C3.922 3 1 5.924 1 9.5 1 13.08 3.922 16 7.5 16S14 13.08 14 9.5C14 5.924 11.078 3 7.5 3zm0 2C9.997 5 12 7.005 12 9.5c0 2.498-2.003 4.5-4.5 4.5A4.485 4.485 0 013 9.5C3 7.005 5.003 5 7.5 5z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M4.12 12.897a1 1 0 00-.692.291l-1.125 1.094a1 1 0 101.394 1.436l1.125-1.094a1 1 0 00-.703-1.727zm6.913.094a1 1 0 00-.68 1.68l.907 1a1 1 0 101.48-1.342l-.906-1a1 1 0 00-.8-.338z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M2.111 1.421a2.5 2.5 0 00-.69 3.468L5.58 2.11a2.5 2.5 0 00-3.468-.69zm10.778 0a2.5 2.5 0 01.69 3.468L9.42 2.11a2.5 2.5 0 013.468-.69z" /></g></svg>;
}

export default SvgComponent;